export default function Hero() {
  return (
    <section id="top" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col items-start gap-2 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-accent-500"></span>
              档案整全整理中 · 已收录 9,126 条
            </div>
            <h2 className="font-heading text-2xl font-black leading-snug text-foreground-950 md:text-4xl md:leading-snug">
              网红主播艺人塌房，<br className="hidden sm:block" />
              历史黑料一键查。
            </h2>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              扒哥黑料档案持续更新，把散落在各处的扒哥黑料汇总、整全整理成可检索的备查资料库。
              吃瓜不迷路——新瓜先到，旧料留档，随时回来对线补课。
            </p>
          </div>

          <div className="mt-6 w-full max-w-sm lg:mt-0 lg:shrink-0">
            <div className="rounded-md border border-background-300 bg-background-50 p-1.5">
              <form
                className="flex items-center gap-2"
                onSubmit={(e) => e.preventDefault()}
              >
                <i className="ri-search-line ml-1 text-base text-foreground-400" aria-hidden="true"></i>
                <input
                  type="search"
                  name="keyword"
                  placeholder="搜网红 / 主播 / 艺人 / 事件"
                  className="w-full bg-transparent text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none"
                />
                <button
                  type="submit"
                  className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  搜档案
                </button>
              </form>
            </div>
            <p className="mt-2 px-1 text-xs text-foreground-500">
              近期检索：陆川叙 · 晚风几重 · 一只柠檬 · 老K不K
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}